import { useTranslation } from "react-i18next";
import { EventListItemDto } from "../../autogen/bff-api";
import { useApiError } from "../../common/errors/useApiError";
import { useCopyProcurement } from "./useCopyProcurement";

export const useBuyerEventRowActions = () => {
  const { t } = useTranslation();
  const { triggerSoft } = useApiError();
  const { copy: copyV2Event, isCopying, modal: copyModal } = useCopyProcurement({ onError: triggerSoft });

  const copyEvent = async (event: EventListItemDto) => copyV2Event(event.id);

  return {
    copyEvent,
    isCopying,
    copyModal,
    copyDisabledReason: (event: EventListItemDto) =>
      event.canEdit ? undefined : t("Only admins and creators can copy events"),
  };
};
